<template>
  <div class="contacts">
    <HeroText
      :heroH1="''"
      :heroH2="'Punti vendita'"
      :heroP="'Chiamaci per richiedere un appuntamento, <br/> o vieni a trovarci in una delle nostre sedi.'"
      :internalPage="true"/>
    <stores />
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"/>
    <ContactsForm />
    <FooterArea />
  </div>
</template>

<script>

import HeroText from '@/components/HeroText/HeroText.vue'
import ContactsForm from '@/components/ContactsForm/ContactsForm.vue'
import Stores from '@/components/Stores/Stores.vue'
import FooterArea from '@/components/FooterArea/FooterArea.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'Contacts',
  components: {
    HeroText,
    ContactsForm,
    Stores,
    FooterArea
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  }
}
</script>

<style lang="scss">
  @import "./contacts.scss";
</style>
